import React from "react";

function Offer({ offer }) {
  return (
    <div className="col s12 m4 offer-card">
      <div className="card">

        <img className="image center" src={offer.logo} alt="logo" />
        <div className="card-content">
          <p style={{ textOverflow: 'ellipsis', minHeight: '100px' }}>{offer.description}</p>
          <div className="card-title center-align">Tarif : {offer.tarif}</div>
          <div className="center-align">
            <div className="chip tarif">Non pris en charge</div>
          </div>
        </div>
        <a href="javascript:void(0)">
          <div className="card-action center-align">
            Consultez l&apos;offre
          </div>
        </a>
      </div>
    </div>
  )
}

export default Offer;